import { useScrollIntoView } from 'modules/authentication';
import React from 'react';

interface Props {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  dataCy?: string;
  containerClassName?: string;
}

export const AITextField: React.FC<Props> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  dataCy,
  containerClassName = 'field',
}) => {
  const { handleFocus } = useScrollIntoView();

  return (
    <div className={containerClassName}>
      <label htmlFor={id} className="t-label t-text-2">
        {label}
      </label>
      <div className="s-top--tny">
        <input
          id={id}
          type="text"
          autoComplete="off"
          onFocus={handleFocus}
          className="input input__med input__box"
          placeholder={placeholder}
          data-cy={dataCy}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
      </div>
    </div>
  );
};
